/** Agent id from a Configure "create data source" return path. `/agents/new` is not an agent. */
export function agentIdFromReturnTo(returnTo: string | null): string | null {
  if (!returnTo) return null;
  const match = returnTo.match(/\/agents\/([^/?#]+)/);
  const id = match?.[1] ? decodeURIComponent(match[1]) : null;
  if (!id || id === 'new') return null;
  return id;
}

/** Keep the tab query when sending the user back to Configure. */
export function returnPath(returnTo: string, returnTab: string | null): string {
  if (returnTab && !returnTo.includes('tab=')) {
    const joiner = returnTo.includes('?') ? '&' : '?';
    return `${returnTo}${joiner}tab=${encodeURIComponent(returnTab)}`;
  }
  return returnTo;
}

/** Desired agent ids after linking one more agent. Missing lists are treated as empty. */
export function nextAgentIds(
  existing: string[] | null | undefined,
  agentId: string,
): string[] {
  const ids = Array.isArray(existing) ? existing.filter(Boolean) : [];
  if (ids.includes(agentId)) return ids;
  return [...ids, agentId];
}
